var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('blockquote',{staticClass:"quote",attrs:{"cite":"#source of the quote"}},[_c('div',[_vm._v(" "+_vm._s(_vm.quote.content)+" "),_c('cite',[_vm._v(" "+_vm._s(_vm.quote.person)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }